import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import FullLogo from 'assets/icons/footer/Web-full-logo3x.png';
import DetourLogo from 'assets/icons/footer/Detour OH TRAILS App Logo_FIN_LOGO_WHT H.png';
import RecTrailsLogo from 'assets/icons/footer/recTrailsSign.png';
import FacebookLogo from 'assets/icons/footer/fb.png';
import InstagramLogo from 'assets/icons/footer/ig.png';
import YoutubeLogo from 'assets/icons/footer/yt.png';
import TwitterLogo from 'assets/icons/footer/tt.png';
import Link from '@material-ui/core/Link';
// JSON & Styles
import { makeStyles } from '@material-ui/core/styles';

const URLS = {
  MORE_INFO: 'https://ohiodnr.gov/wps/portal/gov/odnr/go-and-do/outdoor/ohio-trails-app',
  FAQ: 'https://ohiodnr.gov/wps/portal/gov/odnr/odnr-help-center/detour-help/detour-help',
  PRIVACY_POLICY: 'https://ohiodnr.gov/wps/portal/gov/odnr/go-and-do/outdoor/ohio-trails-app/detour-privacy-policy',
  TERMS_AND_CONDITIONS:
    'https://ohiodnr.gov/wps/portal/gov/odnr/go-and-do/outdoor/ohio-trails-app/detour-terms-conditions',
  PARTNERS: 'https://ohiodnr.gov/wps/portal/gov/odnr/go-and-do/outdoor/ohio-trails-app/our-partners',
  FACEBOOK: 'https://www.facebook.com/ohiodnr/',
  TWITTER: 'https://twitter.com/ohiodnr',
  INSTAGRAM: 'https://www.instagram.com/ohiodnr',
  YOUTUBE: 'https://www.youtube.com/channel/UCTDncLvyVE2MFkd2a6806LA',
  OHIO_DNR: 'https://ohiodnr.gov/wps/portal/gov/odnr/',
  REC: 'https://www.fhwa.dot.gov/environment/recreational_trails/',
};

const Subfooter = () => {
  const useStyles = makeStyles({
    container: {
      padding: '10px 0',
      backgroundColor: '#2A2F36',
    },
    centerRoot: {
      justifyContent: 'center',
    },
    text: {
      boxSizing: 'border-box',
      color: 'rgb(255, 255, 255)',
      cursor: 'pointer',
      display: 'inline',
      fontFamily: 'Open Sans',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '400',
      marginRight: '4px',
      textAlign: 'center',
      textDecorationThickness: 'auto',
      width: 'auto',
      lineHeight: '20px',
      letterSpacing: '0.25px',
    },
    infoFlex: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '6px',
    },
    flex: {
      display: 'flex',
      flexDirection: 'column',
      gap: '25px',
    },
    socialIconsFlex: {
      display: 'flex',
      gap: '15px',
    },
    toolbarRoot: {
      gap: '50px',
      justifyContent: 'space-around',
    },
    getSocial: {
      fontFamily: 'Montserrat',
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
    },
    pointer: {
      cursor: 'pointer',
    },
  });
  const classes = useStyles();

  const handleEnter = (keyCode, fn) => {
    if (keyCode === 13) {
      fn();
    }
  };

  return (
    <AppBar position='static' color='primary' className={classes.container} classes={{ root: classes.centerRoot }}>
      <Container maxWidth={false}>
        <Toolbar classes={{ root: classes.toolbarRoot }}>
          <div className={classes.infoFlex} classes={{ root: classes.text }}>
            <Link href={URLS.MORE_INFO} target='_blank' aria-label='More Information Link'>
              <Typography variant='body1' color='inherit' classes={{ root: classes.text }}>
                More Information
              </Typography>
            </Link>
            <Link
              href={URLS.FAQ}
              target='_blank'
              variant='body1'
              color='inherit'
              classes={{ root: classes.text }}
              aria-label='Frequently Asked Questions Link'
            >
              <Typography variant='body1' color='inherit' classes={{ root: classes.text }}>
                Frequently Asked Questions
              </Typography>
            </Link>
            <Link
              href={URLS.PRIVACY_POLICY}
              target='_blank'
              variant='body1'
              color='inherit'
              classes={{ root: classes.text }}
              aria-label='Privacy Policy Link'
            >
              <Typography variant='body1' color='inherit' classes={{ root: classes.text }}>
                Privacy Policy
              </Typography>
            </Link>
            <Link
              href={URLS.TERMS_AND_CONDITIONS}
              target='_blank'
              variant='body1'
              color='inherit'
              classes={{ root: classes.text }}
              aria-label='Terms and Conditions Link'
            >
              <Typography variant='body1' color='inherit' classes={{ root: classes.text }}>
                Terms and Conditions
              </Typography>
            </Link>
            <Link
              href={URLS.PARTNERS}
              target='_blank'
              variant='body1'
              color='inherit'
              classes={{ root: classes.text }}
              aria-label='Our Partners Link'
            >
              <Typography variant='body1' color='inherit' classes={{ root: classes.text }}>
                Our Partners
              </Typography>
            </Link>
          </div>
          <img
            src={FullLogo}
            alt='Ohio Department of Natural Resources'
            aria-label='Ohio Department of Natural Resources Link'
            className={classes.pointer}
            onClick={() => {
              window.open(URLS.OHIO_DNR, '_blank');
            }}
            tabIndex='0'
            onKeyUp={(e) => {
              handleEnter(e.keyCode, () => window.open(URLS.OHIO_DNR, '_blank'));
            }}
          />
          <img
            src={DetourLogo}
            alt='Detour Ohio Trails'
            aria-label='Detour Ohio Trails'
            width='130'
            height='130'
            tabIndex='0'
          />
          <img
            src={RecTrailsLogo}
            alt='Recreational Trails'
            aria-label='Recreational Trails Link'
            width='80'
            height='80'
            onClick={() => {
              window.open(URLS.REC, '_blank');
            }}
            className={classes.pointer}
            tabIndex='0'
            onKeyUp={(e) => {
              handleEnter(e.keyCode, () => window.open(URLS.REC, '_blank'));
            }}
          />
          <div className={classes.flex}>
            <Typography variant='h5' color='inherit' classes={{ h5: classes.getSocial }} aria-label='Get Social'>
              Get Social
            </Typography>
            <div className={classes.socialIconsFlex}>
              <img
                src={FacebookLogo}
                alt='Facebook'
                aria-label='Facebook Link'
                onClick={() => {
                  window.open(URLS.FACEBOOK, '_blank');
                }}
                className={classes.pointer}
                tabIndex='0'
                onKeyUp={(e) => {
                  handleEnter(e.keyCode, () => window.open(URLS.FACEBOOK, '_blank'));
                }}
              />
              <img
                src={TwitterLogo}
                alt='Twitter'
                aria-label='Twitter Link'
                onClick={() => {
                  window.open(URLS.TWITTER, '_blank');
                }}
                className={classes.pointer}
                tabIndex='0'
                onKeyUp={(e) => {
                  handleEnter(e.keyCode, () => window.open(URLS.TWITTER, '_blank'));
                }}
              />
              <img
                src={InstagramLogo}
                alt='Instagram'
                aria-label='Instagram Link'
                onClick={() => {
                  window.open(URLS.INSTAGRAM, '_blank');
                }}
                className={classes.pointer}
                tabIndex='0'
                onKeyUp={(e) => {
                  handleEnter(e.keyCode, () => window.open(URLS.INSTAGRAM, '_blank'));
                }}
              />
              <img
                src={YoutubeLogo}
                alt='Youtube'
                aria-label='Youtube Link'
                onClick={() => {
                  window.open(URLS.YOUTUBE, '_blank');
                }}
                className={classes.pointer}
                tabIndex='0'
                onKeyUp={(e) => {
                  handleEnter(e.keyCode, () => window.open(URLS.YOUTUBE, '_blank'));
                }}
              />
            </div>
          </div>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Subfooter;
